<template>
	<div class="cat" v-if="items.length">
		<div class="title">
			{{ data.title }} <span class="count">{{ items.length }}</span>
		</div>
		<div class="items">
			<item
				v-for="item in items"
				:item="item"
				:catId="data.id"
				:height="data.height"
				:width="data.width"
				:key="item.id"
			></item>
		</div>
	</div>
</template>

<script>
import item from "./row-item.vue";

export default {
	components: {item},
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	computed: {
		search() {
			return this.$store.state.search.toLowerCase();
		},
		items() {
			const items = this.data.items;
			if (!this.search) return items;
			return items.filter((item) => {
				const name = `${item.company.toLowerCase()} ${item.title.toLowerCase()}`;
				return name.includes(this.search);
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.cat {
	padding: 3em 0;
	border-bottom: 1px solid $greylight2;
	&:last-child {
		border-bottom: 0;
	}

	@include res {
		font-size: 1.1em;
	}

	@include mobile {
		text-align: center;
	}
}
.title {
	display: inline-block;
	position: relative;
	font-size: 1.6em;
	font-weight: 400;
	margin: 0;
	margin-bottom: 0.2em;

	@include mobile {
		text-align: center;
	}
}
.count {
	position: absolute;
	top: 0;
	right: -0.9em;
	vertical-align: super;
	font-size: 0.6em;
	font-weight: 300;
}
.items {
	display: flex;
	flex-wrap: wrap;
	@include mobile {
		justify-content: center;
	}
}
</style>
